module.exports = __webpack_public_path__ + "img/logo-GIS.937bcc7d.png";